import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "../util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            id: '',
            idCheckDuplicate: false,
            idDuplicate: false,
            nick: '',
            nickCheckDuplicate: false,
            nickDuplicate: false,
            name: '',
            password: '',
            passwordConfirm: '',
            birth: '',
            sex: '',
            phone: '',
            phoneCheckDuplicate: false,
            phoneDuplicate: false,
            sns_1: '',
            sns_2: '',
            sns_3: '',
            introduce: '',
            status: '',
            account: '',
            point: '',
            portfolio: '',
            profile: [],
            thumbnail: [],
            background: [],
            mingle: '',

            files: [],

            m_type: '',
            isRequirePassword: true,
        }
    },
    validators: {
        id: function (value) {
            return Validator.value(value)
                .required('아이디를 입력해 주세요.')
                .email('이메일 형식으로 입력해 주세요.')
        },
        idCheckDuplicate: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.idDuplicate) {
                        return '중복된 아이디입니다.';
                    }
                  /*  if(!this.idCheckDuplicate) {
                        return '아이디 중복체크를 진행해주세요.';
                    }*/
                })
        },
        nick:function (value) {
            return Validator.value(value)
                .required('닉네임을 입력해 주세요.')
                .minLength(2, '2 ~ 20자로 작성 해 주세요.')
                .maxLength(20, '2 ~ 20자로 작성 해 주세요.')
        },

        nickCheckDuplicate: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.nickDuplicate) {
                        return '중복된 닉네임입니다.';
                    }
                   /* if(!this.nickCheckDuplicate) {
                        return '닉네임 중복체크를 진행해주세요.';
                    }*/
                })
        },
        name: function (value) {
            return Validator.value(value)
                .required('이름을 입력해 주세요.')
                .minLength(2, '이름을 입력해 주세요.')
                .regex('^[ㄱ-ㅎ|가-힣|]+$', '이름은 한글만 입력 가능합니다.')
        },

        password: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(util.isEmpty(value) && this.isRequirePassword) {
                        return '비밀번호를 입력해주세요.'
                    }
                })
                // .required('비밀번호를 입력해 주세요.')
                .minLength(8, '비밀번호는 8~20자 이내로 입력해 주세요.')
                // .regex('^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,20}$', '비밀번호는 영문+숫자+특수문자로 조합해주세요.')
                .regex('^.*(?=^.{8,20}$)(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$', '비밀번호는 영문+숫자+특수문자로 조합해주세요.')
        },
        passwordConfirm: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(util.isEmpty(value) && this.isRequirePassword) {
                        return '비밀번호를 입력해주세요.'
                    }
                })
                // .required('비밀번호 확인을 입력해 주세요.')
                .custom(() => {
                    if(this.password != value) {
                        return '비밀번호와 같지 않습니다.'
                    }
                })
        },
        phone: function (value) {
            return Validator.value(value)
                // .required('전화번호를 입력해 주세요.(숫자만)')
                .minLength(9, '전화번호를 입력해 주세요.(숫자만)')
                .regex('^[0-9|]+$', '전화번호를 입력해 주세요.(숫자만)')
        },
        phoneCheckDuplicate: function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(this.phoneDuplicate) {
                        return '중복된 전화번호입니다.';
                    }
                /*    if(!this.phoneCheckDuplicate) {
                        return '전화번호 중복체크를 진행해주세요.';
                    }*/
                })
        },
        status: function (value) {
            return Validator.value(value)
        },
        files: function (value) {
            return Validator.value(value)
                .required('사업자등록증을 선택해 주세요.')
                .custom(() => {
                    if(value.length === 0) {
                        return '사업자등록증을 선택해 주세요.';
                    }
                })
        },
        portfolio: function (value) {
            return Validator.value(value)
                // .required('내용을 입력해주세요.')
        },
    },
    methods: {
        checkIdDuplicate() {
            if(this.idCheckDuplicate) {
                return false;
            }
            this.$validate(['id']).then(success => {
                if(!success) {
                    return false;
                }
                let params = {
                    mb_id: this.id,
                };
                try {
                    this.$api.$member.checkIdDuplicate(params).then(res => res.Data.Result).then(res => {
                        let type = res.Info.type;
                        this.checkIdAfter(type);
                    })
                }catch (e) {
                    console.log(e);
                }
            });
        },
        checkIdAfter(type) {
            if(type === 1) {
                this.idCheckDuplicate = true;
                this.idDuplicate = false;
            }else{
                this.idCheckDuplicate = false;
                this.idDuplicate = true;
            }
        },
        checkNickDuplicate() {
            if(this.nickCheckDuplicate) {
                return false;
            }
            this.$validate(['nick']).then(success => {
                if(!success) {
                    return false;
                }
                let params = {
                    mb_nick: this.nick,
                };
                try {
                    this.$api.$member.checkNickDuplicate(params).then(res => res.Data.Result).then(res => {
                        let type = res.Info.type;
                        this.checkNickAfter(type);
                    })
                }catch (e) {
                    console.log(e);
                }
            });
        },
        checkNickAfter(type) {
            if(type === 1) {
                this.nickCheckDuplicate = true;
                this.nickDuplicate = false;
            }else{
                this.nickCheckDuplicate = false;
                this.nickDuplicate = true;
            }
        },
        checkPhoneDuplicate() {
            if(this.phoneCheckDuplicate) {
                return false;
            }
            this.$validate(['phone']).then(success => {
                if(!success) {
                    return false;
                }
                let params = {
                    mb_hp: this.phone,
                    m_type: this.m_type
                }
                try {
                    this.$api.$member.checkPhoneDuplicate(params).then(res => res.Data.Result).then(res => {
                        let type = res.Info.type;
                        this.checkPhoneAfter(type);
                    })
                }catch (e) {
                    console.log(e);
                }
            })
        },
        checkPhoneAfter(type) {
            if(type === 1) {
                this.phoneCheckDuplicate = true;
                this.phoneDuplicate = false;
            }else{
                this.phoneCheckDuplicate = false;
                this.phoneDuplicate = true;
            }
        },
    },
}
